module.exports = __webpack_public_path__ + "img/marker_two_green2.8d8b2de9.png";